module.exports = __webpack_public_path__ + "static/img/scene-5.384baf84.jpg";